
export const tenants = {
  methods: {
    //TODO: 获取租户地图信息
    async getTenantsMap() {
      let res = await this.$http.get("/tenant/map/ground/setting/info");
    
      return res.data;
    },

    //TODO: 获取租户台账模板配置信息
    async getTenantsTemplate() {
      let res = await this.$http.get("/tenant/docConfig/getMyself");
      return res.data;
    },

     //TODO: 获取租户信息
     async getTenantInfo2() {
      let res = await this.$http.get(`/tenant/safeTenant/getSafeTenantDetail`);
      return res.data;
    },

  },
};
